import React from 'react';
const milestones = [{
  phase: 'Now',
  users: '500–1K',
  milestone: 'Product-market fit signal in 3 cities, first widget contracts',
  unlocks: 'Seed round'
}, {
  phase: '6–12 mo',
  users: '5K–10K',
  milestone: '30% weekly retention, widget revenue, 3+ city partnerships',
  unlocks: 'Series A signal'
}, {
  phase: '12–24 mo',
  users: '50K–100K',
  milestone: 'Data licensing revenue, behavioral vibe map at scale',
  unlocks: 'Acquisition interest from mapping / real estate / AV'
}, {
  phase: '24–36 mo',
  users: '500K+',
  milestone: 'Multi-city density, sponsored routes live, city partnerships at scale',
  unlocks: 'Strategic acquisition or Series B'
}];
const fundingItems = ['Operations', 'Key hires — CMO, UX/UI', 'GTM validation', 'Monetization validation', 'Product development'];
export function AskSlide() {
  return <section className="slide" style={{
    backgroundColor: '#0d1520'
  }} data-id="element-117">
      <div className="flex flex-col w-full h-full min-h-0 relative overflow-hidden" data-id="element-118">
        {/* Header */}
        <div className="flex-shrink-0 flex flex-col" style={{
        padding: 'clamp(1.5rem, 3vw, 3rem) clamp(2rem, 6vw, 6rem) 0'
      }} data-id="element-119">
          <p className="italic font-semibold animate-fade-slide" style={{
          color: '#4A90D9',
          fontSize: 'var(--body-size)',
          marginBottom: 'clamp(0.2rem, 0.4vw, 0.35rem)',
          animationDelay: '0.1s'
        }} data-id="element-120">
            The Ask.
          </p>
          <h1 className="font-black tracking-tight leading-[0.95] text-white animate-fade-slide" style={{
          fontSize: 'var(--title-size)',
          animationDelay: '0.15s'
        }} data-id="element-121">
            $1–2M Funding
          </h1>
        </div>

        {/* Two-column body */}
        <div className="flex-1 flex min-h-0 overflow-hidden" style={{
        padding: 'clamp(1rem, 2vw, 1.5rem) clamp(2rem, 6vw, 6rem) clamp(1.5rem, 3vw, 2.5rem)',
        gap: 'clamp(1.5rem, 3vw, 3rem)'
      }} data-id="element-122">
          {/* Left — Use of Funds */}
          <div className="flex-shrink-0 flex flex-col animate-fade-slide" style={{
          width: 'clamp(180px, 22vw, 280px)',
          animationDelay: '0.25s'
        }} data-id="element-123">
            <div className="rounded-xl" style={{
            backgroundColor: 'rgba(74, 144, 217, 0.08)',
            border: '1px solid rgba(74, 144, 217, 0.2)',
            borderLeft: '3px solid #4A90D9',
            padding: 'clamp(0.75rem, 1.5vw, 1.25rem) clamp(1rem, 2vw, 1.5rem)'
          }} data-id="element-124">
              <p className="uppercase tracking-[0.15em] font-semibold" style={{
              color: '#4A90D9',
              fontSize: 'clamp(0.55rem, 0.9vw, 0.75rem)',
              marginBottom: 'clamp(0.6rem, 1.2vw, 1rem)'
            }} data-id="element-125">
                Use of Funds
              </p>
              <div className="flex flex-col" style={{
              gap: 'clamp(0.35rem, 0.8vw, 0.6rem)'
            }} data-id="element-126">
                {fundingItems.map((item, i) => <div key={i} className="flex items-start" style={{
                gap: 'clamp(0.4rem, 0.8vw, 0.6rem)'
              }} data-id="element-127">
                    <div className="flex-shrink-0 rounded-full mt-[3px]" style={{
                  width: 'clamp(6px, 0.6vw, 8px)',
                  height: 'clamp(6px, 0.6vw, 8px)',
                  backgroundColor: '#4A90D9'
                }} data-id="element-128" />
                    <span className="text-white/80 leading-snug" style={{
                  fontSize: 'var(--body-size)'
                }} data-id="element-129">
                      {item}
                    </span>
                  </div>)}
              </div>
            </div>
          </div>

          {/* Right — Milestone Table */}
          <div className="flex-1 flex flex-col min-w-0 animate-fade-slide" style={{
          animationDelay: '0.35s'
        }} data-id="element-130">
            <p className="uppercase tracking-[0.15em] font-semibold" style={{
            color: '#4A90D9',
            fontSize: 'clamp(0.55rem, 0.9vw, 0.75rem)',
            marginBottom: 'clamp(0.6rem, 1.2vw, 1rem)'
          }} data-id="element-131">
              Key Milestones
            </p>

            {/* Table header */}
            <div className="flex w-full" style={{
            paddingBottom: 'clamp(0.4rem, 0.8vw, 0.6rem)',
            borderBottom: '1px solid rgba(255,255,255,0.1)',
            marginBottom: 'clamp(0.3rem, 0.6vw, 0.5rem)'
          }} data-id="element-132">
              <div className="w-[15%]" data-id="element-133">
                <span className="uppercase tracking-[0.1em] font-semibold" style={{
                color: 'rgba(255,255,255,0.35)',
                fontSize: 'clamp(0.5rem, 0.8vw, 0.65rem)'
              }} data-id="element-134">
                  Phase
                </span>
              </div>
              <div className="w-[12%]" data-id="element-135">
                <span className="uppercase tracking-[0.1em] font-semibold" style={{
                color: 'rgba(255,255,255,0.35)',
                fontSize: 'clamp(0.5rem, 0.8vw, 0.65rem)'
              }} data-id="element-136">
                  Users
                </span>
              </div>
              <div className="w-[48%]" data-id="element-137">
                <span className="uppercase tracking-[0.1em] font-semibold" style={{
                color: 'rgba(255,255,255,0.35)',
                fontSize: 'clamp(0.5rem, 0.8vw, 0.65rem)'
              }} data-id="element-138">
                  Milestone
                </span>
              </div>
              <div className="w-[25%]" data-id="element-139">
                <span className="uppercase tracking-[0.1em] font-semibold" style={{
                color: 'rgba(255,255,255,0.35)',
                fontSize: 'clamp(0.5rem, 0.8vw, 0.65rem)'
              }} data-id="element-140">
                  Unlocks
                </span>
              </div>
            </div>

            {/* Table rows */}
            <div className="flex flex-col" data-id="element-141">
              {milestones.map((m, i) => <div key={i} className="flex w-full items-start" style={{
              padding: 'clamp(0.4rem, 0.8vw, 0.65rem) 0',
              borderBottom: i < milestones.length - 1 ? '1px solid rgba(255,255,255,0.06)' : 'none'
            }} data-id="element-142">
                  <div className="w-[15%]" data-id="element-143">
                    <span className="font-semibold" style={{
                  color: i === 0 ? '#4A90D9' : 'rgba(255,255,255,0.6)',
                  fontSize: 'clamp(0.6rem, 1vw, 0.8rem)'
                }} data-id="element-144">
                      {m.phase}
                    </span>
                  </div>
                  <div className="w-[12%]" data-id="element-145">
                    <span className="font-mono" style={{
                  color: 'rgba(255,255,255,0.5)',
                  fontSize: 'clamp(0.55rem, 0.9vw, 0.75rem)'
                }} data-id="element-146">
                      {m.users}
                    </span>
                  </div>
                  <div className="w-[48%] pr-2" data-id="element-147">
                    <span className="leading-snug" style={{
                  color: 'rgba(255,255,255,0.75)',
                  fontSize: 'clamp(0.55rem, 0.9vw, 0.75rem)'
                }} data-id="element-148">
                      {m.milestone}
                    </span>
                  </div>
                  <div className="w-[25%]" data-id="element-149">
                    <span className="rounded-full inline-block font-medium" style={{
                  backgroundColor: i === 0 ? 'rgba(74, 144, 217, 0.15)' : 'rgba(255,255,255,0.06)',
                  color: i === 0 ? '#4A90D9' : 'rgba(255,255,255,0.5)',
                  fontSize: 'clamp(0.5rem, 0.8vw, 0.65rem)',
                  padding: 'clamp(2px, 0.25vw, 4px) clamp(6px, 0.8vw, 10px)',
                  border: i === 0 ? '1px solid rgba(74, 144, 217, 0.3)' : '1px solid rgba(255,255,255,0.08)'
                }} data-id="element-150">
                      {m.unlocks}
                    </span>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}